<template lang="pug">
    article#transferenciaEAproveitamento
        Banner
        //- Transferencia
        //- Funciona
        //- Economia
        Ingressar
        Aproveitamento
        //- Ingressar2
        //- Prouni
        Inscreva
        Textolegal
        Inscricao
</template>

<script>
import Banner from "@sections/TransferenciaEaproveitamento/Banner/Banner.vue"
import Transferencia from "@sections/TransferenciaEaproveitamento/Transferencia/Transferencia.vue"
import Economia from "@sections/TransferenciaEaproveitamento/Economia/Economia.vue"
import Prouni from "@sections/TransferenciaEaproveitamento/Prouni/Prouni.vue"
import Ingressar from "@sections/TransferenciaEaproveitamento/Ingressar/Ingressar.vue"
import Ingressar2 from "@sections/TransferenciaEaproveitamento/Ingressar2/Ingressar2.vue"
import Funciona from "@sections/TransferenciaEaproveitamento/Funciona/Funciona.vue"
import Textolegal from "@sections/TransferenciaEaproveitamento/Textolegal/Textolegal.vue"
import Inscreva from "@sections/TransferenciaEaproveitamento/Inscreva/Inscreva.vue"
import Aproveitamento from "@sections/TransferenciaEaproveitamento/Aproveitamento/Aproveitamento.vue"
import Inscricao from "@components/Inscricao/Inscricao.vue"

import pagina from '@/mixins/pagina'

export default {
    name: "view-transferencia-e-aproveitamento",
    components: {
        Banner,
        Transferencia,
        Funciona,
        Ingressar,
        Ingressar2,
        Prouni,
        Aproveitamento,
        Economia,
        Textolegal,
        Inscreva,
        Inscricao
    },
    mixins: [
        pagina
    ],
}
</script>

<style lang="stylus" scoped src="./TransferenciaEAproveitamento.styl"></style>